import React, {useEffect, useRef, useState} from "react";

import { gsap } from "gsap/all";

import classes from "./LandingLoading.module.css"
import logo from"../../images/logo.ico"


//This is the component of the Loading animation at the start 
const LandingLoading = props =>{
 
  const log = useRef(null)

  // removes the component visibility after it's done
    const [visible, setVisible] = useState(true);

    //runs the animation only Oncea
    useEffect(() => {
      gsap.timeline().to(log.current,{
        duration: 1,
        scale:0.5,
        opacity:1,
        // ease:Elastic.easeOut,
      })
      const timer = setTimeout(() => {
        setVisible(false);
      }, 3000);
      return () => clearTimeout(timer)
    }, []);



    return visible ? <div className={classes.container}>

      {/* the logo in the middle of the loading animation */}
        <img src={logo} alt="logo" ref={log}/> 

        {/* display empty div if visible === false */}
    </div> : <div />

}
export default LandingLoading;